import { render, staticRenderFns } from "./RgHistorySettingButton.vue?vue&type=template&id=6340d834&scoped=true&"
import script from "./RgHistorySettingButton.vue?vue&type=script&lang=js&"
export * from "./RgHistorySettingButton.vue?vue&type=script&lang=js&"
import style0 from "./RgHistorySettingButton.vue?vue&type=style&index=0&id=6340d834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6340d834",
  null
  
)

export default component.exports